import { getAlignItemsByPosition, Position } from 'common/js/creative-position';
import React from 'react';
import { Iframe } from '../iframe';
import TagInject from '../tag-inject';
import style from './styles.scss';
import { AdParser } from '../../../legacy/common/js/AdParser';

interface Props {
  isReady: boolean;
  useSimpleInjection: boolean;
  tag: string;
  containerSelector: string;
  shouldRefreshFrameOnRotation: boolean;
  forceResponsiveHtml: boolean;
  onClickIgnored?: (e: ClickEvent) => void;
  creativePosition?: Position;
  marginTop?: string;
  onIframeResized?: (params: { boundingClientRect: DOMRect }) => void;
  disableUseCustomClose: boolean;
  injectMRAID?: boolean;
  supportMRAIDExpand?: boolean;
  adParser?: AdParser;
}

export function getTagHtml(tag: string) {
  return `<html><head><meta name="viewport" content="width=device-width, initial-scale=1.0, user-scalable=no"></head><body>${tag}</body></html>`;
}

export function TagInjector(props: Props) {
  return (
    <>
      {props.isReady &&
        (props.useSimpleInjection ? (
          <div
            className={style.htmlCreativeWrapper}
            style={{
              alignItems: getAlignItemsByPosition(props.creativePosition),
              marginTop: `${props.marginTop || 0}px`
            }}
            onClick={e => {
              props.onClickIgnored && props.onClickIgnored(e as ClickEvent);
            }}
          >
            <Iframe
              onIframeResized={props.onIframeResized}
              srcDoc={getTagHtml(props.tag)}
              shouldRefreshFrameOnRotation={props.shouldRefreshFrameOnRotation}
              forceResponsiveHtml={props.forceResponsiveHtml}
              position={props.creativePosition}
              disableUseCustomClose={props.disableUseCustomClose}
              injectMRAID={props.injectMRAID}
              supportMRAIDExpand={props.supportMRAIDExpand}
              renderConfig={props.adParser?.render_config}
              backendWidth={props.adParser?.dimensions?.width}
              backendHeight={props.adParser?.dimensions?.height}
            />
          </div>
        ) : (
          <TagInject
            code={props.tag}
            containerSelector={props.containerSelector}
          />
        ))}
    </>
  );
}
